import React from "react";
import useIrregularInterval from "../../hooks/useIrregularInterval";
import { css } from "glamor";

const useWrapperPropDefault = (prop, wrapperProp) =>
    React.useMemo(() => prop || wrapperProp, [prop]);
const parseNumber = (str) => parseFloat(str.replace(/[^0-9.]/g, ""));

export const createAnimationWrapper = (
    wrapperAnimation,
    {
        animation,
        delay: wrapperDelay = "0s",
        duration: wrapperDuration = "1s",
        loop: wrapperLoop = "1",
        fillMode: wrapperFillMode,
        direction: wrapperDirection,
        easing: wrapperTimingFunction,
    } = {}
) => (props) => {
    const loop = useWrapperPropDefault(props.loop, wrapperLoop);
    const delay = useWrapperPropDefault(props.delay, wrapperDelay);
    const duration = useWrapperPropDefault(props.duration, wrapperDuration);
    const [isPlaying, setIsPlaying] = React.useState(true);
    const [iteration, setIteration] = React.useState(0);

    const delayNumber = parseNumber(delay);
    const durationNumber = parseNumber(duration);

    const onInterval = React.useCallback((index) => {
        switch (index) {
            case 0:
                setIsPlaying(false);
                break;
            case 1:
                setIteration(iteration + 1);
                setIsPlaying(true);
                break;
        }
    }, []);

    const totalDuration = delayNumber + durationNumber;
    useIrregularInterval(onInterval, [
        durationNumber * 1000,
        delayNumber * 1000,
    ]);

    const animation = { ...wrapperAnimation, ...(props.animation || {}) };

    return (
        <div
            {...css({
                display: `inline-block`,
                transformOrigin: `center`,
                animationPlayState: isPlaying ? "running" : "paused",
                animationName: `${css.keyframes(animation)}`,
                animationDuration: duration,
                animationIterationCount: loop === true ? "infinite" : loop,
                animationFillMode: useWrapperPropDefault(
                    props.fillMode,
                    wrapperFillMode
                ),
                animationDirection: useWrapperPropDefault(
                    props.direction,
                    wrapperDirection
                ),
                animationTimingFunction: useWrapperPropDefault(
                    props.easing,
                    wrapperTimingFunction
                ),
            })}
        >
            {props.children}
        </div>
    );
};

export default createAnimationWrapper;
